(function () {
  function initGallery(gallery) {
    if (gallery.dataset.skinseiReady) return;
    gallery.dataset.skinseiReady = 'true';
    var slides = Array.from(gallery.querySelectorAll('.sk-gallery__slides img'));
    var count = gallery.querySelector('[data-gallery-count]');
    var current = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      if (count) count.textContent = '0' + (current + 1) + ' / 0' + slides.length;
    }

    gallery.querySelector('[data-gallery-prev]').addEventListener('click', function () { show(current - 1); });
    gallery.querySelector('[data-gallery-next]').addEventListener('click', function () { show(current + 1); });
  }

  function initHome(home) {
    if (home.dataset.skinseiReady) return;
    home.dataset.skinseiReady = 'true';
    home.querySelectorAll('[data-skinsei-gallery]').forEach(initGallery);
    var ritualRows = Array.from(home.querySelectorAll('.sk-ritual__row'));
    ritualRows.forEach(function (row) {
      row.addEventListener('toggle', function () {
        if (!row.open) return;
        ritualRows.forEach(function (other) { if (other !== row) other.open = false; });
      });
    });

    var modal = home.querySelector('[data-skinsei-modal]');
    if (!modal) return;

    var modalImage = modal.querySelector('[data-modal-image]');
    var imageCache = new Map();
    var openRequest = 0;

    function preloadImage(source) {
      if (imageCache.has(source)) return imageCache.get(source);

      var pending = new Promise(function (resolve, reject) {
        var preload = new Image();
        preload.onload = function () {
          if (typeof preload.decode === 'function') {
            preload.decode().catch(function () {}).then(function () { resolve(source); });
          } else {
            resolve(source);
          }
        };
        preload.onerror = reject;
        preload.src = source;
      });

      imageCache.set(source, pending);
      return pending;
    }

    async function openShade(shade) {
      var request = ++openRequest;
      var name = shade.dataset.shadeName;
      var source = shade.dataset.shadeImage;

      try {
        await preloadImage(source);
      } catch (error) {
        imageCache.delete(source);
        return;
      }

      if (request !== openRequest) return;

      modal.querySelector('[data-modal-name]').textContent = name;
      modal.querySelector('[data-modal-note]').textContent = shade.dataset.shadeNote;
      modal.querySelector('[data-modal-undertone]').textContent = shade.dataset.shadeUndertone;
      modal.querySelector('[data-modal-profile]').textContent = shade.dataset.shadeProfile;
      modal.querySelector('[data-modal-cta]').textContent = 'Choose ' + name;
      modalImage.src = source;
      modalImage.alt = name + ' shown in the Skinsei Labs compact';

      if (!modal.open) modal.showModal();
      modal.querySelector('[data-modal-close]').focus({ preventScroll: true });
    }

    home.querySelectorAll('[data-shade-button]').forEach(function (shade) {
      shade.addEventListener('click', function () { openShade(shade); });
    });

    modal.querySelectorAll('[data-modal-close]').forEach(function (button) {
      button.addEventListener('click', function () { modal.close(); });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) modal.close();
    });

    modal.addEventListener('close', function () {
      openRequest += 1;
      modalImage.removeAttribute('src');
      modalImage.alt = '';
    });

    var preloadAll = function () {
      home.querySelectorAll('[data-shade-button]').forEach(function (shade) {
        preloadImage(shade.dataset.shadeImage).catch(function () {});
      });
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadAll, { timeout: 1500 });
    } else {
      window.setTimeout(preloadAll, 0);
    }

    home.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        if (modal.open) modal.close();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initAll(root) {
    if (root.matches && root.matches('.sk-home')) initHome(root);
    root.querySelectorAll('.sk-home').forEach(initHome);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
